





























































































import ErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { log } from '@/log'
import { iosCustomUrlSchemes, navigateToHlAppDeeplink, navigateToHlAppDeeplinkWithDelay } from '@/models/hl-app/custom-url-scheme'
import { stringifyErrorForEndUser } from '@/models/payment/creditcard/repository/errors'
import { registerNewCreditcard } from '@/models/payment/creditcard/service/register-new-creditcard'
import { purchaseContext } from '@/models/payment/creditcard/service/register-new-creditcard/dependencies'
import CreditcardForm from '@spa/components/organisms/payment/creditcard/CreditcardForm.vue'
import { CreditcardFormState } from '@spa/components/organisms/payment/creditcard/creditcardFormState'
import CreditCardDescription from '@spa/components/organisms/payment/description/CreditCardDescription.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { User } from '@spa/store/modules/user/types'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    CreditCardDescription,
    CreditcardForm,
    ErrorDialog,
  },
})
export default class RegisterCreditCard extends Mixins<PluginMixin & LoadingMixin>(PluginMixin, LoadingMixin) {
  status: Status = Status.Pending
  showModal: boolean = false
  modalMessage: string = ''

  formState: CreditcardFormState = {
    cardNumber: '',
    cardOwner: '',
    expireMonth: '',
    expireYear: '',
    securityCode: '',
  }

  /**
   * クロネコのスクリプトのロードから登録処理までの時間が短いとエラーになるらしいのでこのタイミングで初期化している。
   * 詳細はCreditcardRegisterServiceのコンストラクタのコメントを参照。
   */
  readonly context = purchaseContext()

  async created() {
    await this.$store.dispatch('user/get')
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  get user(): User {
    return this.$store.state.user.user
  }

  onCardNumberChange(value: string): void {
    this.formState.cardNumber = value
  }

  onCardOwnerChange(value: string): void {
    this.formState.cardOwner = value
  }

  onExpireMonthChange(value: string): void {
    this.formState.expireMonth = value
  }

  onExpireYearChange(value: string): void {
    this.formState.expireYear = value
  }

  onSecurityCodeChange(value: string): void {
    this.formState.securityCode = value
  }

  async submit() {
    try {
      const validated = await this.$validator.validateAll()

      if (!validated) {
        this.modalMessage = '入力内容が正しくありません'
        this.showModal = true

        return
      }

      this.status = Status.Loading

      await registerNewCreditcard(this.context, this.formState, this.user)

      // 1秒間complete表示してからページを閉じる
      this.status = Status.Completed
      const sleep = 1000
      navigateToHlAppDeeplinkWithDelay(iosCustomUrlSchemes.close, sleep)
    } catch (error) {
      log.error({ error })

      this.modalMessage = stringifyErrorForEndUser(error as Error)
      this.showModal = true
      this.status = Status.Failed
    }
  }

  closePage() {
    navigateToHlAppDeeplink(iosCustomUrlSchemes.close)
  }
}
